import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { PropertyModule } from './property';
import { UserModule } from './user';
import { ComponentModule } from './component';
import { WorkspaceModule } from './workspace';
import { DashBoardModule } from './dashboard';
import { ReportsModule } from './reports';
import { RouterModule } from '@angular/router';
import { internalRoutes } from './internal.routes';
import { InternalLayoutComponent } from './layouts';
import { SharedModule } from '../shared';
import { services } from './shared/services';
import { PlansModule } from './plans';
import { PhotoModule } from './photos';
import { FilesModule } from './files';
import { TransactionsModule } from './transactions';
import { SetupModule } from './setup';
import { InternalSharedModule } from './shared';
import { AdminModule } from './admin';
import { MappingModule } from './mapping';
import { EffectsModule } from '@ngrx/effects';
import { InternalEffects } from './shared/internal-store/internal.effects';
import { TagsModule } from './tags/tags.module';
import { CommonModule } from '@angular/common';
import { MaintenanceModule } from './maintenance/maintenance.module';
import { ProjectsModule } from './projects/projects.module';
import { PortfolioAnalyticsModule } from './portfolio-analytics/portfolio-analytics.module';
import { AssetLibraryModule } from './asset-library/asset-library.module';
import { NotificationsModule } from './notifications/notifications.module';
import { UserSettingsModule } from './user-settings/user-settings.module';
import { AccountsModule } from './accounts/accounts.module';
import { SupportingListsModule } from './supporting-lists/supporting-lists.module';
import { MembershipModule } from './membership/membership.module';
import { IntelligenceModule } from './intelligence/intelligence.module';

const PROVIDERS = [
  ...services,
];

@NgModule({
  declarations: [
    InternalLayoutComponent,
  ],
  providers: [
    PROVIDERS
  ],
  imports: [
    CommonModule,
    AdminModule,
    EffectsModule.forFeature([InternalEffects]),
    PropertyModule,
    UserModule,
    ComponentModule,
    WorkspaceModule,
    MappingModule,
    DashBoardModule,
    ReportsModule,
    SharedModule,
    InternalSharedModule,
    FormsModule,
    PlansModule,
    PhotoModule,
    FilesModule,
    TransactionsModule,
    SetupModule,
    RouterModule.forRoot(internalRoutes, {}),
    TagsModule,
    MaintenanceModule,
    ProjectsModule,
    PortfolioAnalyticsModule,
    AssetLibraryModule,
    NotificationsModule,
    UserSettingsModule,
    AccountsModule,
    SupportingListsModule,
    MembershipModule,
    IntelligenceModule,
  ],
})
export class InternalModule {
}
